// src/redux/slices/admin/trainingSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../api';

// Async thunk to fetch training programs
export const fetchTrainingPrograms = createAsyncThunk(
  'training/fetchPrograms',
  async ({page = 1, searchTerm = '', userType = 'Both'}, { rejectWithValue }) => {
    try {
      const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/admin/training-programs-list?page=${page}`, {searchTerm, userType:userType});
      return response.data; // Return the full response for better handling in reducers
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch training programs');
    }
  }
);

// Async thunk to delete a training program
export const deleteTrainingProgram = createAsyncThunk(
  'training/deleteProgram',
  async (programId, { dispatch, rejectWithValue }) => {
    try {
      await api.delete(`${process.env.REACT_APP_API_BASE_URL}/admin/training-program/`+programId);
      var p = {'page':1,'searchTerm':''};
      dispatch(fetchTrainingPrograms(p)); // Fetch updated program list after creation
      return programId;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to delete training program');
    }
  }
);

export const duplicateTrainingProgram = createAsyncThunk(
  'training/duplicateProgram',
  async ({id, currentPage}, { dispatch, rejectWithValue }) => {
    try {
      await api.post(`${process.env.REACT_APP_API_BASE_URL}/admin/duplicate-training-program/`+id);
      var p = {'page':currentPage,'searchTerm':''};
      dispatch(fetchTrainingPrograms(p)); // Fetch updated program list after creation
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to delete training program');
    }
  }
);




// Async thunk to create a new training program
export const createTrainingProgram = createAsyncThunk(
  'training/createProgram',
  async (programData, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/admin/training-program`, programData);

      if (response.data.success) {
        var p = {'page':1,'searchTerm':''};
        dispatch(fetchTrainingPrograms(p)); // Fetch updated program list after creation
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to create training program');
    }
  }
);

// Async thunk to update an existing training program
export const updateTrainingProgram = createAsyncThunk(
  'training/updateProgram',
  async ({programData, id}, { dispatch, rejectWithValue }) => {
    try { 

      const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/admin/update-training-program/${id}`, programData);
      if (response.data.success) {
        var p = {'page':1,'searchTerm':''};
        dispatch(fetchTrainingPrograms(p)); // Fetch updated program list after creation
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to update training program');
    }
  }
);

const trainingSlice = createSlice({
  name: 'trainingPrograms',
  initialState: {
    programs: [],
    currentPage: 1,
    totalPages: 0,
    loading: false,
    error: null,
    successMessage: null,
  },
  reducers: {
    // Clear messages
    clearMessages: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTrainingPrograms.pending, (state) => {
        state.loading = true;
        state.error = null; // Clear previous errors on new fetch
      })
      .addCase(fetchTrainingPrograms.fulfilled, (state, action) => {
        state.loading = false;
        state.programs = action.payload.data.data || []; // Ensure programs are set even if data is undefined
        state.currentPage = action.payload.data.current_page || 1; // Default to 1 if current_page is undefined
        state.totalPages = action.payload.data.last_page || 0; // Default to 0 if last_page is undefined
      })
      .addCase(fetchTrainingPrograms.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Capture error message for debugging
      })
      .addCase(deleteTrainingProgram.fulfilled, (state, action) => {
        state.programs = state.programs.filter(program => program.id !== action.payload);
      })
      .addCase(deleteTrainingProgram.rejected, (state, action) => {
        state.error = action.payload; // Handle error on rejection
      })

      .addCase(duplicateTrainingProgram.fulfilled, (state, action) => {
        //state.programs = state.programs.filter(program => program.id !== action.payload);
      })
      .addCase(duplicateTrainingProgram.rejected, (state, action) => {
        state.error = action.payload; // Handle error on rejection
      })


      .addCase(createTrainingProgram.fulfilled, (state, action) => {
        if (action.payload.success) {
          state.successMessage = 'Training program created successfully';
        } else {
          state.error = action.payload.message; // Handle error from response
        }
      })
      .addCase(createTrainingProgram.rejected, (state, action) => {
        state.error = action.payload; // Handle error on rejection
      })
      .addCase(updateTrainingProgram.fulfilled, (state, action) => {
        if (action.payload.success) {
          const index = state.programs.findIndex(program => program.id === action.payload.data.id);
          if (index !== -1) {
            state.programs[index] = action.payload.data; // Update with new data
          }
          state.successMessage = 'Training program updated successfully';
        } else {
          state.error = action.payload.message; // Handle error from response
        }
      })
      .addCase(updateTrainingProgram.rejected, (state, action) => {
        state.error = action.payload; // Handle error on rejection
      });
  },
});

// Export actions and reducer
export const { clearMessages } = trainingSlice.actions;

export default trainingSlice.reducer;